import Transform from "@ember-data/serializer/transform";

export default class TargetedTherapiesTransform extends Transform {
  override deserialize(serialized) {
    serialized?.forEach(targetedTherapy => {
      // Make sure date are of type Date and not string.
      // This is useful when passing the date in a DatePicker, which must have a Date and not a string.
      if (targetedTherapy.startDate) {
        targetedTherapy.startDate = new Date(targetedTherapy.startDate);
      }
      if (targetedTherapy.endDate) {
        targetedTherapy.endDate = new Date(targetedTherapy.endDate);
      }
    });
    return serialized;
  }

  override serialize(deserialized) {
    return deserialized;
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    "targeted-therapies": TargetedTherapiesTransform;
  }
}
